import { OrganizationUrlProps, RolesUrlProps } from "@logic";
import { UrlPath } from "@shared/helpers";
import { organizationUrl } from "../organizations";

export const rolesUrl: UrlPath<OrganizationUrlProps> = `${organizationUrl}/role`
export const roleUrl: UrlPath<RolesUrlProps> = `${rolesUrl}/:role`
export const memberRoleUrl: UrlPath<RolesUrlProps> = `${roleUrl}/member`
